import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import { Box } from "@mui/system";
import AdvancedTable from "@saleor/apps/components/AdvancedTable/AdvancedTable";
import MyTypography from "@saleor/components/MyTypography";
import usePagination from "@saleor/createOrChangeNotRefContract/hooks/usePagination";
import useSortPriceCalc from "@saleor/createOrChangeNotRefContract/hooks/useSortPriceCal";
import { FormikProps } from "formik";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl/lib";

import useStyles from "./styles";
import useCPResultData from "./useCPResultData";

export interface CPResultProps {
  visible?: boolean;
  formikCPItemDetails: FormikProps<any>;
  formikItemDetails: FormikProps<any>;
  onAcceptConfirmDate: () => void;
  onNotAcceptConfirmDate: () => void;
}

const CPResultModal: React.FC<CPResultProps> = props => {
  const {
    visible,
    formikCPItemDetails,
    formikItemDetails,
    onAcceptConfirmDate,
    onNotAcceptConfirmDate
  } = props;

  const classes = useStyles();

  const updateSalesUnits = () => {
    const cpItems = formikCPItemDetails?.values?.lines ?? [];
    const items = formikItemDetails?.values?.lines ?? [];
    for (const cpItem of cpItems) {
      const match = items.find(item => item.itemNo === cpItem.itemNo);
      if (match) {
        cpItem.salesUnit = match.salesUnit || "";
      }
    }
  };

  useEffect(() => {
    updateSalesUnits();
  }, [formikCPItemDetails, formikItemDetails]);

  const { currentData } = usePagination(formikCPItemDetails);
  const showItems = formikCPItemDetails?.values?.lines?.filter(
    item => item?.showInPopup === true
  );

  const { handleSort, sortDirection } = useSortPriceCalc(formikCPItemDetails);
  const { columnsList, emptyMiddleware } = useCPResultData(
    formikCPItemDetails,
    sortDirection
  );

  return (
    <Dialog
      open={visible}
      className={classes.root}
      data-testid="cp-result-modal"
    >
      <DialogTitle className={classes.dialogTitle}>
        <MyTypography variant={"h6"} className={classes.nameHead}>
          ประมาณการส่งมอบ ไม่ตรงกับวันที่ต้องการสินค้า
        </MyTypography>
        <MyTypography variant={"h7"} className={classes.itemText}>
          {`${showItems?.length || 0} รายการ`}
        </MyTypography>
      </DialogTitle>
      <Box className={classes.Pad}>
        <Box className={classes.ListWrapper}>
          <AdvancedTable
            rootClassName={classes.CpTable}
            cellAlign="center"
            headHeight={48}
            cellheight={48}
            columnsList={columnsList}
            rowsData={currentData()}
            onRowClick={null}
            borderRequired={false}
            middleware={emptyMiddleware}
            tableKey="itemNo"
            handleSort={() => {
              handleSort();
            }}
            sortDirection={new Map([["itemNo", sortDirection]])}
            reRenderKey="id"
          />
        </Box>
      </Box>

      <DialogActions className={classes.buttonPanel}>
        <Button
          id="confirmDateButton"
          variant={"contained"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={onAcceptConfirmDate}
        >
          <FormattedMessage defaultMessage={"ยอมรับ Confirm Date"} />
        </Button>
        <Button
          id="cancelDateButton"
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={onNotAcceptConfirmDate}
        >
          <FormattedMessage defaultMessage={"ไม่ยอมรับ Confirm Date"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CPResultModal;
